const getUrlParameter = (name) => {
  let paramName = name;
  paramName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
  const results = regex.exec(location.search);
  if (results === null) {
    return "";
  }
  const raw = results[1].replace(/\+/g, " ");
  try {
    return decodeURIComponent(raw);
  } catch {
    // malformed percent-encoding (e.g. a stray "%") — fall back to the raw value
    // rather than throwing and breaking every caller of this shared helper.
    return raw;
  }
};

export default getUrlParameter;
